/**
 * edj-urgency.js
 * Simulation visiteurs pour la bannière urgence — VAGUE 2 item 14
 *
 * Pour chaque [data-edj-urgency], on génère une fois par session un nombre
 * aléatoire entre data-min et data-max, persisté en sessionStorage pour
 * éviter le re-render brutal au rechargement.
 *
 * Scope :
 *   - current_product → clé sessionStorage par product-id (lu sur l'ancêtre [data-product-id])
 *   - whole_site      → clé globale partagée
 *
 * Template : data-template contient `__N__` qui sera remplacé par le nombre.
 */
(function () {
  'use strict';

  function getProductId(el) {
    const ancestor = el.closest('[data-product-id]');
    return ancestor ? ancestor.getAttribute('data-product-id') : '';
  }

  function getStorageKey(el) {
    const scope = el.getAttribute('data-scope') || 'current_product';
    if (scope === 'whole_site') return 'edj_urgency_global';
    const pid = getProductId(el);
    return 'edj_urgency_' + (pid || 'unknown');
  }

  function getOrCreateCount(el) {
    const min = parseInt(el.getAttribute('data-min'), 10) || 8;
    const max = parseInt(el.getAttribute('data-max'), 10) || 25;
    const key = getStorageKey(el);

    let stored = null;
    try {
      stored = window.sessionStorage.getItem(key);
    } catch (e) {}

    if (stored) {
      const n = parseInt(stored, 10);
      if (Number.isFinite(n) && n >= min && n <= max) return n;
    }

    const n = Math.floor(Math.random() * (max - min + 1)) + min;
    try {
      window.sessionStorage.setItem(key, String(n));
    } catch (e) {}
    return n;
  }

  function init() {
    document.querySelectorAll('[data-edj-urgency]').forEach(el => {
      if (el.__edjUrgencyInit) return;
      el.__edjUrgencyInit = true;

      const visitorsEl = el.querySelector('[data-edj-urgency-visitors]');
      if (!visitorsEl) return;

      const template = el.getAttribute('data-template') || '__N__ personnes consultent ce produit';
      const n = getOrCreateCount(el);
      visitorsEl.textContent = template.replace('__N__', String(n));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
